module.exports = __webpack_public_path__ + "img/htkj_04.7dc90942.jpg";